/**
 * Author[Lakshay Jain]
 * Version 1.0.1
 * 7th December | 1.0.1 | Shubham Rawat | Hid the Travel and fee Config option from nav
 * 26th December | 1.0.2 | Shubham Rawat | Added Reports Dashboard
*/
import React, { useEffect, useState} from 'react'
import {
	ExpandableSidebar,
	Loader,
	NavDivider,
	Navigation,
	NotFound,
	PageLoad,
	Pages,
	Tabs,
	Wrapper
} from "../../../../retro";
import {Route, Switch, useHistory, useLocation, useParams} from "react-router-dom";
import Users from './Users'
import VirtualAccounts from "./VirtualAccounts/VirtualAccounts";
import Bulkpe from "./Bulkpe/Bulkpe"
import ApiWallet from "./Wallet/ApiWallet";
import Settings from "./Settings";
import Apps from "./Apps";
import RouteR from './Apis/Route'
import AllApis from "./Apis/allApis";
import {get} from "../../../Network/Axios";
import AllUsers from './Users/Users'
import AllAdmins from './Users/Admins'
import AllOffices from "./Users/Offices"
import AllScanners from './Users/Scanners'
import Modules from './Modules'
import Deployments from './TravelConfig'
import Market from './Market'
import Authentication from './Authentication'
import QueuesIcon from "@atlaskit/icon/glyph/queues";
import PeopleGroupIcon from "@atlaskit/icon/glyph/people-group";
import useFunctionallityHook from "../../../Hooks/useFunctionallityHook";
import Dashboard from './Dashboard';
import DemoClientDashboard from '../DemoClient/DemoClientDashboard';
import CardsConfiguration from '../DemoClient/CardConfiguration';
import DemoModules from '../DemoClient/Modules';
import DemoRoute from '../DemoClient/DemoRoute';
import useLocalHook from 'retro/Hooks/useLocalHook';

export default function Index() {
	return (
		<ClientDetails/>
	)
}

function ClientDetails() {
	const {id} = useParams();
	const saas = window.location.origin.includes('cockpit.dice.tech') || window.location.origin.includes('localhost');
	const [module, setmodule] = useState(undefined)
	const [Data, SetData] = useState({
		loading: true,
	})
	const items = [

	]
	const HISTORY = useHistory();
	const Location = useLocation();

	const FUNCTIONALITIES = useFunctionallityHook();

	useEffect(() => {
		if (Data.loading) {
			get(`/clients/${id}`, (e, r) => {
				if (r) {
					PageLoad(`All Apis for ${r.name}`)
					SetData({
						...r,
						loading: false
					})
				}
			})
		}
	}, [id, Data.loading])
useEffect(()=>{
	getModule()
},[])

function getModule(){

	get(`/clients/modules/${id}`, (e, r) => {
        if (r) {
			setmodule(r)
        } else {
          setError(true);
        }
      });

}


	if (Data.loading) {
		return (
			<div>
				<Loader/>
			</div>
		)
	}
	let controlRoomItems = [
		{
			title:"All clients",
			icon: (<QueuesIcon size="small"/>),
			active:Location.pathname === '/app/clients',
			onClick:()=>{
				HISTORY.push('/app/clients')
			}
		},
		{
			title: "Create New Client",
			icon: (<PeopleGroupIcon size="small" />),
			active: Location.pathname.includes('/app/clients/new'),
			onClick: () => {
				HISTORY.push('/app/clients/new')
			}
		},
	]

	if (FUNCTIONALITIES.gstUtility) {
		controlRoomItems.splice(1, 0, {
			title: 'Gst Utility',
			icon: <QueuesIcon size='small' />,
			active: Location.pathname === '/app/clients/gst',
			onClick: () => {
				HISTORY.push('/app/clients/gst');
			},
		})
	}
	items.push({
		title: "Control Room",
		actions: controlRoomItems
	})


	return (
		<>
			<div className="flex h-100h w-100">
				<ExpandableSidebar items={items} />
				<Wrapper>
					<Navigation backUrl={''} title={Data.name} chips={['All Clients', Data.code]} description={Data.name} />
					<Tabs style={{
						marginBottom: 'calc(-2rem - 1px)',
					}} className="" tabs={[
						{
							title: "Dashboard",
							href: "/app/client/" + id + "/dashboard",
						},
						{
							title: "All Users",
							href: "/app/client/" + id + "/users",
						},
						{
							title: "Modules",
							href: "/app/client/" + id + "/modules",
						},
						...saas && (id == 10004494 || id==10004496) ? [{
								title: "Cards Configuration",
								href: "/app/client/" + id + "/cards-configuration",
							}] : [],
						{
							title: "Functionalities",
							href: "/app/client/" + id + "/apis",
						},
						...FUNCTIONALITIES.deposit && (id!= 10004494 && id!=10004496)? [
							{
								title: "Virtual Accounts",
								href: "/app/client/" + id + "/accounts",
							}
						] : [],

						...module?.bulkPe ? [{
							title: "Bulkpe",
							href: "/app/client/" + id + "/Bulkpe",
						}] : [],
						...FUNCTIONALITIES.travelAndFeeConfig && (id!= 10004494 && id!=10004496) ? [
							{
								title: "Travel Fee & Configuration",
								href: "/app/client/" + id + "/deployments",
							}] : [],
						...FUNCTIONALITIES.sso ? [{
							title: "Saml/Sso",
							href: "/app/client/" + id + "/authentication",
						}] : [],
						{
							title: "Settings",
							href: "/app/client/" + id + "/settings",
						}
					]} />
					<NavDivider />
					<div style={{ marginTop: -18 }}>
						<Pages.Page>
							<Switch>
								<Route component={(id == 10004494 || id==10004496) ? DemoClientDashboard : Dashboard} path="/app/client/:id/dashboard" />
								<Route component={Users} path="/app/client/:id/users" />
								<Route exact={true} component={(id==10004494 || id==10004496) ? DemoRoute : AllApis} path="/app/client/:id/apis" />
								<Route component={RouteR} path="/app/client/:id/apis" />
								<Route component={ApiWallet} path="/app/client/:id/api/wallet" />
								<Route component={Settings} path="/app/client/:id/settings" />	
								<Route component={Apps} path="/app/client/:id/apps" />
								<Route component={CardsConfiguration} path="/app/client/:id/cards-configuration" />
								<Route component={Market} path="/app/client/:id/market" />
								<Route
									path="/app/client/:id/modules"
									render={(props) => {
										const { id } = props.match.params; // route param is always a string
										if (id === "10004494" || id=="10004496") {            // compare with string
											return <DemoModules />;
										} else {
											return <Modules {...props} getModule={getModule} />;
										}
									}}
								/>


								<Route component={Authentication} path="/app/client/:id/authentication" />
								<Route component={VirtualAccounts} path="/app/client/:id/accounts" />
								<Route component={Bulkpe} path="/app/client/:id/Bulkpe" />
								<Route component={Deployments} path="/app/client/:id/deployments" />
								<Route component={AllUsers} path="/app/client/:id/employees" />
								<Route component={AllAdmins} path="/app/client/:id/admins" />
								<Route component={AllOffices} path="/app/client/:id/offices" />
								<Route component={AllScanners} path="/app/client/:id/scanners" />
								<NotFound />
							</Switch>
						</Pages.Page>
					</div>
				</Wrapper>
			</div>
		</>
	)
}
